/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 11:12:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-29 17:58:27
 */
import { Col, Tabs } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectPotionFlag } from '../../../app/applicationSlice'
import { selectPage } from '../../Inventorystock/InventStockSlice'
import { ReplaceMakeOrder } from '../order/ReplaceMakeOrder'
import { LocalReplaceMakeOrder } from './LocalOrder/ReplaceMakeOrder'
import styles from './ReplaceMakeOrderTabs.module.css'

export const ReplaceMakeOrderTabs = (): ReactElement => {
  const location: any = useLocation()

  const potionFlag: any = useSelector(selectPotionFlag)
  
  const [tabSelect, setTabSelect] = useState<any>(potionFlag == 0 ? '0' : '1')

  useEffect(() => {
    if (location?.state?.selectKey) {
      setTabSelect(location?.state?.selectKey || (potionFlag == 0 ? '0' : '1'))
    }
  }, [location])

  return (
    <Col className={styles.replaceMakeOrderTabsMain}>
      <Tabs
        activeKey={tabSelect}
        style={{ margin: '0 20px', height: '100%' }}
        tabBarExtraContent={
          <div style={{ color: '#999999' }}>
            （最多支持导出10000条数据，更多请联系客服）
          </div>
        }
        onChange={(v) => {
          setTabSelect(v)
        }}
      >
        {potionFlag == 0 ? (
          <Tabs.TabPane key='0' tab='委外代煎订单'>
            <ReplaceMakeOrder tabKey={tabSelect} />
          </Tabs.TabPane>
        ) : (
          ''
        )}
        <Tabs.TabPane key='1' tab='本地代煎订单'>
          <LocalReplaceMakeOrder tabKey={tabSelect} />
        </Tabs.TabPane>
      </Tabs>
    </Col>
  )
}
